var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"instructor-home"}},[(['My-Bulbs','Classes','Folders','Students','Playlists', 'Premade-Bulbs','My-Videos'].includes(_vm.activeView))?_c('InstructorTableContainer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }